import Record from "./base"
import { Itemimage } from "store/serializers/itemimage"
import modelItemImage from "../models/itemimage"

export class Item extends Record {
  constructor(...props) {
    super(...props)
    const [model, data] = props
    this.image = data.image.map(image => {
      return new Itemimage(modelItemImage, {
        ...image,
        auctionCode: data.auction_id,
        isMarketplaceItem:
          data.marketplace_provider_id && data.marketplace_provider_id > 0
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/serializers/item.js